import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    user:null,
    role:null,
    companyId:null,
    userId:null,
    first_time:null
}

const authSlice = createSlice({
    name:"auth",
    initialState,
    reducers:{
        setAuth:(state,action)=>{
            state = {...state,...action.payload}
            return state
        },
        removeAuth:(state,action)=>{
            state = initialState
            return state
        }
    }
})

export const {setAuth,removeAuth} = authSlice.actions

export default authSlice.reducer;